import React from 'react';
import 'twin.macro';
import { StaticImage } from 'gatsby-plugin-image';

import CardLink, { cardLinkImageStyles } from '~components/Card/CardLink';

const DiseaseModifyingCard: React.FC = () => (
  <CardLink to="/accelerating-research/disease-modifying-therapy" variant="blue" title="Le projet de financement du DT1 donne des résultats positifs en matière de thérapie modificatrice">
    <StaticImage src="../../images/t1d-fund-project-feature.jpg" alt="" style={cardLinkImageStyles} />
  </CardLink>
);

export default DiseaseModifyingCard;
